<template>
      <div class="infoCard">
       <b-table-simple>
            <b-thead>
                <b-th> {{$t('signal.postpone.account')}} </b-th>
                <b-th> {{$t('signal.postpone.signalDate')}} </b-th>
                <b-th> {{$t('signal.postpone.signal')}} </b-th>
                <b-th> {{$t('signal.postpone.zone')}} </b-th>
                <b-th> {{$t('signal.postpone.postponeEndDate')}} </b-th>
                <b-th> {{$t('signal.postpone.postponeTime')}} </b-th>
                <b-th> {{$t('signal.list.actions')}} </b-th>
            </b-thead>
            <b-tbody>
                <b-tr v-for="ps in postponeSignals" :key="ps.id" v-b-popover.hover="popoverConfig([{user_info:{username: 'Osman'}, note: $t('signal.postpone.note')}])"> 
                    <b-td> {{ps.signal_info.account_no}} - {{ps.signal_info.part_no}} {{ps.signal_info.account_info.name}} </b-td>
                    <b-td> {{moment(ps.signal_date)}}</b-td>
                    <b-td> {{ps.signal_info.alarm_code}} - {{ps.signal_info.signal_settings.description}} </b-td>
                    <b-td> {{ps.signal_info.zone_desc}}  </b-td>
                    <b-td v-b-popover.hover="popoverTime(ps.PostponeFinishTime)"> {{moment(ps.PostponeFinishTime)}} </b-td>
                    <b-td> {{ps.Period}} {{$t('signal.signalProcess.min')}} </b-td>
                    <b-td> <b-button variant="outline-danger" @click="cancelPostpone(ps)"> {{$t('signal.postpone.cancel')}}</b-button> </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>
     
    </div>
</template>

<style lang="css" scoped > 
    @import "../styles/add.min.css"; 
</style>

<script>
    import moment from 'moment'
    export default {
        name: "PostponeList",
       
        computed:{
            postponeSignals() {
                return this.$store.getters.getPostponeSignals;
            },
        },
        props: {
            data: Object,
            save: Boolean,
            saveState: Function,
            modalEvent: Function,
            modalName: String
        },
        watch: {
            save: function(data){
                this.saveState(false)
                this.modalEvent(false)

            }
        },
        methods:{
            moment: function(data){
                return moment(data).format('DD MMMM YYYY HH:mm');
            },
            cancelPostpone: async function(ps){
                let data = {
                    postpone_id: ps.id
                }
                await this.$store.dispatch('removePostpone', data)
                await this.$store.dispatch('postponeSignals')

                
            },
             popoverConfig(data) {
                return {
                    html: true,
                    placement: 'bottom',
                    customClass: 'popoverFluid',
                    content: () => {
                        let content = ""
                        if(data){
                                for( let i = 0; i < data.length; i++)
                            content += '<strong>'+i18n.t('signal.list.user')+': </strong>'+ data[i].user_info.username+ ' <strong>'+i18n.t('signal.list.signalNotes')+': </strong>'+ data[i].note +'<br />'
                        }
                        
                        return content
                    },
                }
            },
            popoverTime(data) {
                    return {
                        html: true,
                        placement: 'top',
                        content: () => {
                            let content = moment(data).diff(moment(), 'minutes ') + i18n.t('signal.signalProcess.minLater')
                            
                            return content
                        },
                    }
                },
        }
        
    }
</script>


// WEBPACK FOOTER //
// src/pages/Alarmsis/Signal/modals/PostponeList.vue